/* Newbe Product Page — interactions + Shopify wiring (document-scoped) */
(function () {
  'use strict';
  // The script is referenced by several sections (header, buy-box, hero); run once.
  if (window.__nbeInit) return;
  window.__nbeInit = true;
  if (!document.querySelector('.nbx')) return;

  /* ---- Gallery: image + video slides ---- */
  var stage = document.querySelector('[data-nb-stage]');
  if (stage) {
    var slides = Array.prototype.slice.call(stage.querySelectorAll('.gslide'));
    var playActiveVideo = function () {
      slides.forEach(function (sl) {
        if (sl.tagName !== 'VIDEO') return;
        if (sl.classList.contains('is-active')) { var pr = sl.play(); if (pr && pr.catch) pr.catch(function () {}); }
        else { sl.pause(); }
      });
    };
    var activateSlide = function (i) {
      slides.forEach(function (sl) { sl.classList.toggle('is-active', sl.getAttribute('data-nb-slide') === String(i)); });
      playActiveVideo();
    };
    document.querySelectorAll('.thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        document.querySelectorAll('.thumb').forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
        activateSlide(t.getAttribute('data-nb-thumb'));
      });
    });
    // autoplay the active video on load, on hover, and when scrolled into view
    playActiveVideo();
    stage.addEventListener('mouseenter', playActiveVideo);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.target.tagName !== 'VIDEO') return;
          if (e.isIntersecting && e.target.classList.contains('is-active')) { var pr = e.target.play(); if (pr && pr.catch) pr.catch(function () {}); }
          else e.target.pause();
        });
      }, { threshold: 0.4 });
      slides.forEach(function (sl) { if (sl.tagName === 'VIDEO') io.observe(sl); });
    }
  }

  /* ---- Buy-box state ---- */
  var buybox = document.querySelector('[data-nb-buybox]');
  var currentSize = buybox ? (buybox.getAttribute('data-default-size') || '3') : '3';
  var currentVariant = buybox ? (buybox.getAttribute('data-default-variant') || '') : '';
  var priceOne = buybox ? buybox.getAttribute('data-price-one') || '' : '';
  var priceSub = buybox ? buybox.getAttribute('data-price-sub') || '' : '';
  var subPer = buybox ? buybox.getAttribute('data-sub-per') || '/mnd' : '/mnd';
  var perdaySub = buybox ? buybox.getAttribute('data-perday-sub') || '' : '';
  var perdayOne = buybox ? buybox.getAttribute('data-perday-one') || '' : '';
  var hasDisc = buybox ? buybox.getAttribute('data-has-disc') === 'true' : false;

  function activePlan() {
    var p = document.querySelector('[data-plan].active');
    return p ? p.getAttribute('data-plan') : 'Abonnement';
  }

  function refreshCta() {
    /* v3: de knop draagt de prijs, de gekozen maat staat in de kaart-subtitel. */
    var hint = document.querySelector('[data-nb-sizehint]');
    if (hint) hint.textContent = currentSize;
    var cnt = document.querySelector('[data-nb-count]');
    var btn = document.querySelector('.size.active[data-count]');
    if (cnt && btn) cnt.textContent = btn.getAttribute('data-count');
  }

  function refreshPrice() {
    var sub = activePlan() === 'Abonnement';
    var now = document.querySelector('[data-nb-price-now]');
    var per = document.querySelector('[data-nb-price-per]');
    var day = document.querySelector('[data-nb-perday]');
    var was = document.querySelector('[data-nb-was]');
    var cta = document.getElementById('cta-price');
    var toggle = document.querySelector('[data-nb-plan-toggle]');
    var lead = document.querySelector('[data-nb-once-lead]');
    var card = document.querySelector('.nb-buyoffer');
    // legacy price element (if a theme still uses it)
    var legacy = document.querySelector('.nbx-price .now');
    if (now) now.textContent = sub ? priceSub : priceOne;
    if (per) per.style.display = sub ? '' : 'none';
    if (was) was.style.display = sub ? '' : 'none';
    if (day) day.textContent = (sub ? perdaySub : perdayOne) + ' per dag';
    if (cta) cta.textContent = sub ? priceSub : priceOne;
    if (toggle) toggle.textContent = sub ? ('Bestel eenmalig voor ' + priceOne) : ('Kies het abonnement voor ' + priceSub);
    if (lead) lead.textContent = sub ? 'Liever eerst uitproberen?' : 'Toch liever voordeliger?';
    if (card) card.classList.toggle('is-onetime', !sub);
    if (legacy) legacy.innerHTML = (sub ? priceSub + '<span class="per">' + subPer + '</span>' : priceOne);
  }

  /* ---- Size chips ---- */
  document.querySelectorAll('.size').forEach(function (s) {
    s.addEventListener('click', function () {
      if (s.hasAttribute('disabled')) return;
      document.querySelectorAll('.size').forEach(function (x) { x.classList.remove('active'); x.setAttribute('aria-pressed', 'false'); });
      s.classList.add('active');
      s.setAttribute('aria-pressed', 'true');
      currentSize = s.getAttribute('data-size');
      if (s.getAttribute('data-variant-id')) currentVariant = s.getAttribute('data-variant-id');
      // sync gallery badge
      var badge = document.querySelector('.gmain .gbadge');
      if (badge && s.getAttribute('data-badge')) badge.textContent = s.getAttribute('data-badge');
      refreshCta();
    });
  });

  /* ---- v3: tekstlink die de verborgen plan-schakelaar bedient ---- */
  var planLink = document.querySelector('[data-nb-plan-toggle]');
  if (planLink) planLink.addEventListener('click', function (e) {
    e.preventDefault();
    var want = activePlan() === 'Abonnement' ? 'Eenmalig' : 'Abonnement';
    var btn = document.querySelector('[data-plan="' + want + '"]');
    if (btn) btn.click();
  });

  /* ---- Plan toggle (segmented) ---- */
  document.querySelectorAll('[data-plan]').forEach(function (p) {
    p.addEventListener('click', function () {
      document.querySelectorAll('[data-plan]').forEach(function (x) { x.classList.remove('active'); x.setAttribute('aria-selected', 'false'); });
      p.classList.add('active');
      p.setAttribute('aria-selected', 'true');
      refreshCta();
      refreshPrice();
    });
  });

  /* ---- Add to cart ---- */
  var atc = document.getElementById('nb-atc');
  if (atc && buybox) {
    atc.addEventListener('click', function (e) {
      e.preventDefault();
      if (!currentVariant) { window.location.href = '/cart'; return; }
      var sub = activePlan() === 'Abonnement';
      var body = {
        items: [{
          id: parseInt(currentVariant, 10),
          quantity: 1,
          // Firmhouse reads this line-item property to attach the subscription plan.
          properties: { _plan: sub ? 'subscription' : 'onetime' }
        }]
      };
      // Attach the selling plan so the cart charges the subscription price.
      // Prefer a real (native) Shopify selling plan; fall back to Firmhouse id.
      var sp = buybox.getAttribute('data-selling-plan') || buybox.getAttribute('data-firmhouse-plan');
      if (sub && sp) body.items[0].selling_plan = parseInt(sp, 10);
      atc.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        // Open the cart drawer (newbe-cart-drawer.js) instead of navigating away.
        document.dispatchEvent(new CustomEvent('nbc:add'));
      }).catch(function () { window.location.href = '/cart'; })
        .finally(function () { atc.removeAttribute('aria-busy'); });
    });
  }

  /* ---- Sizing wizard slider ---- */
  var range = document.getElementById('weight-range');
  var wOut = document.getElementById('weight-out');
  var rSize = document.getElementById('result-size');
  var rRange = document.getElementById('result-range');
  /* Maten en gewichten volgen de maattabel in nb-sizing.liquid en de
     schema-defaults weight_1..weight_5 in main-product.liquid. De bereiken
     overlappen; de grenzen hieronder liggen midden in elke overlap. */
  function sizeForWeight(kg) {
    if (kg < 3.5) return { s: '1', r: '2–4 kg' };
    if (kg < 7) return { s: '2', r: '3–8 kg' };
    if (kg < 10) return { s: '3', r: '6–11 kg' };
    if (kg < 13) return { s: '4', r: '9–14 kg' };
    return { s: '5', r: '12–17 kg' };
  }
  function updateWizard() {
    if (!range) return;
    var kg = parseFloat(range.value);
    if (wOut) wOut.textContent = kg.toFixed(1);
    var m = sizeForWeight(kg);
    if (rSize && rSize.firstChild) rSize.firstChild.textContent = m.s + ' ';
    if (rRange) rRange.textContent = m.r;
    var pct = (kg - parseFloat(range.min)) / (parseFloat(range.max) - parseFloat(range.min)) * 100;
    range.style.background = 'linear-gradient(90deg, var(--green) ' + pct + '%, rgba(19,69,39,.2) ' + pct + '%)';
  }
  if (range) { range.addEventListener('input', updateWizard); updateWizard(); }

  /* ---- FAQ accordion ---- */
  document.querySelectorAll('.qa button').forEach(function (b) {
    b.addEventListener('click', function () {
      var qa = b.closest('.qa');
      var open = qa.classList.contains('open');
      qa.classList.toggle('open');
      var ans = qa.querySelector('.ans');
      if (ans) ans.style.maxHeight = open ? '0' : (ans.scrollHeight + 'px');
    });
  });

  /* ---- Future gifts toggle ---- */
  document.querySelectorAll('.futuregift').forEach(function (f) {
    f.addEventListener('click', function () {
      var panel = f.nextElementSibling;
      var open = f.classList.toggle('open');
      if (panel && panel.classList.contains('futurepanel')) {
        panel.style.maxHeight = open ? (panel.scrollHeight + 'px') : '0';
      }
    });
  });

  /* ---- Mobile menu ---- */
  var menu = document.getElementById('nbx-mmenu');
  var scrim = document.getElementById('nbx-scrim');
  function openMenu() { if (menu) { menu.classList.add('open'); scrim.classList.add('open'); document.body.style.overflow = 'hidden'; } }
  function closeMenu() { if (menu) { menu.classList.remove('open'); scrim.classList.remove('open'); document.body.style.overflow = ''; } }
  var burger = document.getElementById('nbx-burger');
  if (burger) burger.addEventListener('click', openMenu);
  var mclose = document.getElementById('nbx-mclose');
  if (mclose) mclose.addEventListener('click', closeMenu);
  if (scrim) scrim.addEventListener('click', closeMenu);
  document.querySelectorAll('#nbx-mmenu .mlinks a').forEach(function (a) { a.addEventListener('click', closeMenu); });

  /* ---- Header: mega-menu + search dropdowns ---- */
  var nav = document.querySelector('header.nav');
  if (nav) {
    var megaBtn = nav.querySelector('[data-nb-mega]');
    var searchBtn = nav.querySelector('[data-nb-search]');
    var searchInput = nav.querySelector('.searchbar input');
    function closeMega() { nav.classList.remove('mega-open'); if (megaBtn) megaBtn.setAttribute('aria-expanded', 'false'); }
    function closeSearch() { nav.classList.remove('search-open'); if (searchBtn) searchBtn.setAttribute('aria-expanded', 'false'); }
    if (megaBtn) megaBtn.addEventListener('click', function (e) {
      e.preventDefault();
      closeSearch();
      var open = nav.classList.toggle('mega-open');
      megaBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    if (searchBtn) searchBtn.addEventListener('click', function (e) {
      e.preventDefault();
      closeMega();
      var open = nav.classList.toggle('search-open');
      searchBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && searchInput) setTimeout(function () { searchInput.focus(); }, 30);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeMega(); closeSearch(); } });
    document.addEventListener('click', function (e) {
      if (!nav.contains(e.target)) { closeMega(); closeSearch(); }
    });
  }

  refreshCta();
  refreshPrice();
})();
